// src/components/InvoiceTable/InvoiceTable.tsx
import { List, ListItem, Popover, Table, Text, useMantineTheme } from '@mantine/core';
import React from 'react';
import classes from './InvoiceTable.module.css';

interface InvoiceTableProps {
  data?: {
    uniqueStyles?: number;
    poNo?: string;
    styles?: string[];
    supplier?: string;
    storeData?: Record<string, { totalStyles: number; totalQuantity: number }>;
    message?: string;
  };
}

const InvoiceTable: React.FC<InvoiceTableProps> = ({ data }) => {
  const theme = useMantineTheme();
  const { poNo, uniqueStyles, styles, supplier, storeData } = data || {};

  return (
    <div className={classes.gridColDiv} style={{ backgroundColor: theme.colors.gray[0], color: theme.colors.gray[10] }}>
      <div className={classes.stickyDiv} style={{ backgroundColor: theme.colors.gray[0], color: theme.colors.gray[10], zIndex: 2 }}>
        <div className={classes.gridRowDiv}>
          <Text className={classes.textWithInput}>Po No:</Text>
          <Text className={classes.textWithInput}>{(uniqueStyles === 0 || uniqueStyles === undefined) ? 'New PO' : poNo}</Text>
        </div>

        <div className={classes.gridRowDiv}>
          <Text className={classes.textWithInput}>Supplier:</Text>
          <Text className={classes.textWithInput}>{supplier || ''}</Text>
        </div>

        <div className={classes.gridRowDiv}>
          <Text className={classes.textWithInput}>Total Styles:</Text>
          <Popover width={300} trapFocus position="bottom" withArrow shadow="md">
            <Popover.Target>
              <Text className={classes.textWithInput} style={{ cursor: 'pointer', borderBottom: '2px solid gray' }}>{uniqueStyles ?? 0}</Text>
            </Popover.Target>
            <Popover.Dropdown>
              <List>
                {styles?.map((style, idx) => <ListItem key={style + idx}>{style}</ListItem>)}
              </List>
            </Popover.Dropdown>
          </Popover>
        </div>
      </div>

      <div className={classes.table}>
        <Table border={1} withColumnBorders striped>
          <Table.Thead>
            <Table.Tr className={classes.tableHeader} style={{ backgroundColor: theme.colors.gray[8], color: theme.colors.gray[0] }}>
              <Table.Th>Store</Table.Th>
              <Table.Th>No of Styles</Table.Th>
              <Table.Th>Quantity</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody style={{ overflowY: 'scroll' }}>
            {storeData && Object.keys(storeData).map((storeKey) => {
              const sd = storeData[storeKey];
              return (
                <tr key={storeKey}>
                  <td>{storeKey}</td>
                  <td>{sd?.totalStyles ?? 0}</td>
                  <td>{sd?.totalQuantity ?? 0}</td>
                </tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  );
};


export default InvoiceTable;